export default "__VITE_ASSET__BPS10ihR__"